import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves strategies
 */

export function getStrategiesData(_this, fieldName, fieldShowLoadingName) {
  gatewayService.currencies
    .strategy({ format: "json" })
    .then(data => {
      data.forEach(function(d) {
        d.name = d.strategy_position.toUpperCase() + " " + d.fk_idstrategyname;
        d.calculated = false;
        d.simulated = false;
        delete d.__typename;
        _this.strategies.push(d);
      });
      _this[fieldName] = data;
      _this[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.log(error);
    });
}
